import styled from "styled-components";

export const TestimonialStory = styled.blockquote.attrs({
  className: 'py-s italic font-light'
})`
  grid-area: story;
`;
